module.exports = __webpack_public_path__ + "img/canceled.be6084c3.gif";